module.exports = __webpack_public_path__ + "images/proprietary-dc42603bd08e42b41a93ce5790d92167.jpg";